import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Spinner,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import arrowIcon from "../../assets/images/arrowIcon.svg";

import SetupFieldsDropdown from "../SetupFieldsDropdown";
import MappingWindow from "../mapping/MappingWIndow";
import { Loading } from "../Loading";

import {
  onChangePreferenceForSearchParameters,
  onChangePreferenceForProducts,
  setIsProductSyncRulesSaved,
  onChangePreferenceForCreatingProduct,
} from "../../store/slices/productSlice";
import {
  setShowErrorModal,
  setShowSuccessModal,
} from "../../store/slices/preferenceSlice";
import { getUrl } from "../../helpers/getUrl";

import { useCmsHook } from "../../helpers/cmsHook";

function ProductSyncRules() {
  const { cmsInstance } = useCmsHook();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  const {
    preferencesForProducts,
    productPreference,
    preferenceForSearchParameters,
    txProductFilterPreference,
    hubspotProductFilterPreference,
    preferenceForCreatingProduct,
    defaultProductForCreating,
  } = useSelector((state) => state.product);

  const {
    hubspot: {
      hubspotDropdownFields: {
        productsSearchFields: hubspotProductFields,
        product: hubspotProducts,
      },
      loading: hubspotLoading,
    },
    tripletex: {
      tripletexDropdownFields: {
        productsSearchFields: txProductFields,
        product: txProducts,
      },
      loading: txLoading,
    },
    mapping: {
      defaultMappings: { product: mappings },
    },
    isMappingSaved: { product: isMappingSaved },
  } = useSelector((state) => state.mapping);

  const renderText = () => {
    if (
      hubspotProducts &&
      hubspotProducts.length === 0 &&
      txProducts &&
      txProducts.length === 0
    ) {
      return "Products not found in both HubSpot and Tripletex";
    } else if (hubspotProducts && hubspotProducts.length === 0) {
      return "Products not found in HubSpot";
    } else if (txProducts && txProducts.length === 0) {
      return "Products not found in Tripletex";
    }
  };

  return (
    <div className="sync-settings-setup-page">
      {hubspotLoading || txLoading || !cmsInstance ? (
        <Loading />
      ) : (
        <Container className="px-0">
          <Card className="sync-settings-card" style={{ marginTop: "29px" }}>
            <Card.Body className="sync-settings-card-body">
              <div>
                {cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.product.productSyncRules.block1.text"
                  )}

                <Form.Check
                  type="radio"
                  id="selectSearchParameters"
                  name="productSearchParameters"
                  value="select search parameters"
                  label="Select search parameters"
                  className="mb-3 mt-3"
                  checked={
                    preferenceForSearchParameters === "select search parameters"
                  }
                  onChange={(e) =>
                    dispatch(
                      onChangePreferenceForSearchParameters({
                        selected: e.target.value,
                      })
                    )
                  }
                />

                {preferenceForSearchParameters ===
                  "select search parameters" && (
                  <div className="ms-3 mb-3">
                    {cmsInstance &&
                      cmsInstance.showRichText(
                        "cmsContent.product.productSyncRules.block1.radioBtns.searchParameters"
                      )}
                    {hubspotProductFields &&
                      hubspotProductFields.length > 0 &&
                      txProductFields &&
                      txProductFields.length > 0 && (
                        <Row>
                          <Col sm={5} lg={3}>
                            <b>HubSpot</b>
                            <SetupFieldsDropdown
                              fieldsData={hubspotProductFields}
                              selectedPreference={
                                hubspotProductFilterPreference
                              }
                              dropdownFor="hubspotProductFilterField"
                            />
                          </Col>

                          <Col
                            sm={1}
                            lg={1}
                            className="mx-0 sync-settings-card-direction"
                          >
                            <div>
                              <img src={arrowIcon} alt="arrow-icon" />
                            </div>
                          </Col>

                          <Col sm={5} lg={3}>
                            <b>Tripletex</b>
                            <SetupFieldsDropdown
                              fieldsData={txProductFields}
                              selectedPreference={txProductFilterPreference}
                              dropdownFor="txProductFilterField"
                            />
                          </Col>
                        </Row>
                      )}
                  </div>
                )}

                <Form.Check
                  type="radio"
                  id="setCustomMappings"
                  name="productSearchParameters"
                  value="set custom mappings"
                  label="Set custom mappings"
                  className="mb-3"
                  checked={
                    preferenceForSearchParameters === "set custom mappings"
                  }
                  onChange={(e) =>
                    dispatch(
                      onChangePreferenceForSearchParameters({
                        selected: e.target.value,
                      })
                    )
                  }
                />

                {preferenceForSearchParameters === "set custom mappings" && (
                  <>
                    {hubspotProducts &&
                    hubspotProducts.length > 0 &&
                    txProducts &&
                    txProducts.length > 0 ? (
                      <MappingWindow
                        mapping={mappings}
                        path="cmsContent.product.productSyncRules.block1.radioBtns.customMappings"
                        hubspotDropdownFields={hubspotProducts}
                        tripletexDropdownFields={txProducts}
                        mappingsFor="product"
                        description="This option lets you directly link specific products in HubSpot to specific ones in Fortnox."
                        hubspotLoading={hubspotLoading}
                        txLoading={txLoading}
                      />
                    ) : (
                      <div
                        className="d-flex flex-row justify-content-center w-100"
                        style={{ border: "1px solid #d2dbe6" }}
                      >
                        <p className="search-not-found-para my-3">
                          <b>{renderText()}</b>
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Card.Body>
          </Card>

          {/* {preferencesForProducts === "find create product" && (
            <Card className="sync-settings-card">
              <Card.Body className="sync-settings-card-body">
                <div>
                  <b>Default Mappings</b>

                  <Col sm={5} lg={3} className="mt-4">
                    <b>Select Currency</b>
                    {currency && currency.length > 0 && (
                      <SetupFieldsDropdown
                        dropdownFor="productCurrency"
                        selectedPreference={productCurrencyPreference}
                        fieldsData={currency}
                      />
                    )}
                  </Col>

                  <Col sm={5} lg={3} className="mt-4">
                    <b>Select Department</b>
                    {department && department.length > 0 && (
                      <SetupFieldsDropdown
                        dropdownFor="productDepartment"
                        selectedPreference={productDepartmentPreference}
                        fieldsData={department}
                      />
                    )}
                  </Col>

                  <Col sm={5} lg={3} className="mt-4">
                    <b>Select Unit</b>
                    {productUnit && productUnit.length > 0 && (
                      <SetupFieldsDropdown
                        dropdownFor="productUnit"
                        selectedPreference={productUnitPreference}
                        fieldsData={productUnit}
                      />
                    )}
                  </Col>

                  <Col sm={5} lg={3} className="mt-4">
                    <b>Select Volume</b>
                    {productVolumeUnit && productVolumeUnit.length > 0 && (
                      <SetupFieldsDropdown
                        dropdownFor="productVolume"
                        selectedPreference={productVolumePreference}
                        fieldsData={productVolumeUnit}
                      />
                    )}
                  </Col>

                  <Col sm={5} lg={3} className="mt-4">
                    <b>Select Weight</b>
                    {productWeightUnit && productWeightUnit.length > 0 && (
                      <SetupFieldsDropdown
                        dropdownFor="productWeight"
                        selectedPreference={productWeightPreference}
                        fieldsData={productWeightUnit}
                      />
                    )}
                  </Col>
                </div>
              </Card.Body>
            </Card>
          )} */}

          <Card className="sync-settings-card">
            <Card.Body className="sync-settings-card-body">
              <div>
                {cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.product.productSyncRules.block2.text"
                  )}

                <div className="d-flex flex-column mt-3">
                  <div>
                    <Form.Check
                      type="radio"
                      id="doNotGenerateInvoice"
                      name="productRadioButton"
                      value="do not generate invoice"
                      label="Don't create the invoice"
                      onChange={(e) =>
                        dispatch(
                          onChangePreferenceForProducts({
                            selected: e.target.value,
                          })
                        )
                      }
                      checked={
                        preferencesForProducts === "do not generate invoice"
                      }
                    />
                    {preferencesForProducts === "do not generate invoice" && (
                      <div
                        style={{
                          marginRight: "22px",
                          marginLeft: "22px",
                        }}
                      >
                        {cmsInstance &&
                          cmsInstance.showRichText(
                            "cmsContent.product.productSyncRules.block2.radioBtns.dontCreateInvoice"
                          )}
                      </div>
                    )}
                  </div>
                  <div className="mt-2">
                    <Form.Check
                      type="radio"
                      id="useDefaultProduct"
                      name="productRadioButton"
                      value="use default product"
                      label="use a pre-chosen product"
                      onChange={(e) =>
                        dispatch(
                          onChangePreferenceForProducts({
                            selected: e.target.value,
                          })
                        )
                      }
                      checked={preferencesForProducts === "use default product"}
                    />
                    {preferencesForProducts === "use default product" && (
                      <div
                        style={{
                          marginRight: "22px",
                          marginLeft: "22px",
                        }}
                      >
                        {cmsInstance &&
                          cmsInstance.showRichText(
                            "cmsContent.product.productSyncRules.block2.radioBtns.defaultProduct"
                          )}
                      </div>
                    )}
                    {preferencesForProducts === "use default product" && (
                      <>
                        {txProducts && txProducts.length > 0 ? (
                          <Col sm={5} lg={3} className="ms-3 mt-2">
                            <b>Select product</b>
                            <SetupFieldsDropdown
                              dispatch={dispatch}
                              fieldsData={txProducts}
                              selectedPreference={productPreference}
                              dropdownFor="products"
                            />
                          </Col>
                        ) : (
                          <div
                            className="d-flex flex-row justify-content-center w-100"
                            style={{ border: "1px solid #d2dbe6" }}
                          >
                            <p className="search-not-found-para my-3">
                              <b>No product present in Fortnox.</b>
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="mt-2">
                    <Form.Check
                      type="radio"
                      id="findCreateProduct"
                      name="productRadioButton"
                      value="find create product"
                      label="Create new product"
                      onChange={(e) =>
                        dispatch(
                          onChangePreferenceForProducts({
                            selected: e.target.value,
                          })
                        )
                      }
                      checked={preferencesForProducts === "find create product"}
                    />
                    {preferencesForProducts === "find create product" && (
                      <div className="ms-3 mt-2">
                        {cmsInstance &&
                          cmsInstance.showRichText(
                            "cmsContent.product.productSyncRules.block2.radioBtns.findCreateProduct"
                          )}

                        <Form.Check
                          type="checkbox"
                          id="createProduct"
                          label="Do you have custom products to your deal?"
                          checked={preferenceForCreatingProduct}
                          onChange={(e) =>
                            dispatch(onChangePreferenceForCreatingProduct())
                          }
                        />

                        {preferenceForCreatingProduct && (
                          <>
                            {cmsInstance &&
                              cmsInstance.showRichText(
                                "cmsContent.product.productSyncRules.block2.customProduct"
                              )}
                            {txProducts && txProducts.length > 0 ? (
                              <Col sm={5} lg={3} className="mt-2">
                                <b>Select Product</b>
                                <SetupFieldsDropdown
                                  dispatch={dispatch}
                                  fieldsData={txProducts}
                                  selectedPreference={defaultProductForCreating}
                                  dropdownFor="defaultProduct"
                                />
                              </Col>
                            ) : (
                              <div
                                className="d-flex flex-row justify-content-center w-100"
                                style={{ border: "1px solid #d2dbe6" }}
                              >
                                <p className="search-not-found-para my-3">
                                  <b>No product present in Tripletex.</b>
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>

          <div
            className="d-flex flex-row justify-content-end mb-4"
            style={{ marginTop: "27px" }}
          >
            {(preferencesForProducts === "use default product" &&
              !productPreference) ||
            (preferencesForProducts === "find create product" &&
              preferenceForCreatingProduct === true &&
              !defaultProductForCreating) ||
            (preferenceForSearchParameters === "select search parameters" &&
              (!txProductFilterPreference ||
                !hubspotProductFilterPreference)) ||
            (preferenceForSearchParameters === "set custom mappings" &&
              (checkCountForProductMapped({ mappings }) === 0 ||
                (checkCountForProductMapped({ mappings }) > 0 &&
                  !isMappingSaved))) ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ fontSize: "12px" }}>
                    {showToolTipText(
                      preferencesForProducts,
                      productPreference,
                      isMappingSaved,
                      preferenceForSearchParameters,
                      txProductFilterPreference,
                      hubspotProductFilterPreference,
                      mappings,
                      preferenceForCreatingProduct,
                      defaultProductForCreating
                    )}
                  </Tooltip>
                }
              >
                <Button className="save-changes-disabled-button">Save</Button>
              </OverlayTrigger>
            ) : (
              <Button
                onClick={() =>
                  onSaveProductSyncRules({
                    setIsLoading,
                    dispatch,
                    searchParams,
                    preferencesForProducts,
                    productPreference,
                    preferenceForSearchParameters,
                    hubspotProductFilterPreference,
                    txProductFilterPreference,
                    preferenceForCreatingProduct,
                    defaultProductForCreating,
                  })
                }
                className="save-changes-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span>Save</span>
                )}
              </Button>
            )}
          </div>
        </Container>
      )}
    </div>
  );
}

export default ProductSyncRules;

/**
 * This function is responsible for getting the count of products mapped
 * @returns {Number} count of products mapped
 */
export function checkCountForProductMapped({ mappings }) {
  let count = 0;
  if (mappings && mappings.length > 0) {
    mappings.forEach((mappedItem) => {
      if (mappedItem.HS_Fields && mappedItem.HS_Fields.length > 0) {
        count += 1;
      }
    });
  }
  return count;
}

/**
 * This function is responsible for showing a custom message in Tooltip for Save button.
 */
export const showToolTipText = (
  preferencesForProducts,
  productPreference,
  isMappingSaved,
  preferenceForSearchParameters,
  txProductFilterPreference,
  hubspotProductFilterPreference,
  mappings,
  preferenceForCreatingProduct,
  defaultProductForCreating
) => {
  if (preferencesForProducts === "use default product" && !productPreference) {
    return "please select the default product";
  } else if (
    preferencesForProducts === "find create product" &&
    preferenceForCreatingProduct === true &&
    !defaultProductForCreating
  ) {
    return "Please select the default product for find/create product";
  } else if (
    preferenceForSearchParameters === "select search parameters" &&
    !txProductFilterPreference
  ) {
    return "Please select Tripletex search parameter";
  } else if (
    preferenceForSearchParameters === "select search parameters" &&
    !hubspotProductFilterPreference
  ) {
    return "Please select HubSpot search parameter";
  } else if (
    preferenceForSearchParameters === "set custom mappings" &&
    checkCountForProductMapped({ mappings }) === 0
  ) {
    return "Please map at least one product in the mapping window";
  } else if (
    preferenceForSearchParameters === "set custom mappings" &&
    checkCountForProductMapped({ mappings }) > 0 &&
    !isMappingSaved
  ) {
    return "Please save the product mappings";
  }
};

/**
 * This function is used for saving invoice sync rules
 */
export async function onSaveProductSyncRules({
  setIsLoading,
  dispatch,
  searchParams,
  preferencesForProducts,
  productPreference,
  preferenceForSearchParameters,
  hubspotProductFilterPreference,
  txProductFilterPreference,
  preferenceForCreatingProduct,
  defaultProductForCreating,
}) {
  try {
    setIsLoading(true);
    const portalId = searchParams.get("portalId");
    await axios.post(getUrl("REACT_APP_SAVE_PREFERENCES"), {
      portalId: parseInt(portalId),
      preferences: {
        product: {
          // txFields: {
          //   currency: productCurrencyPreference,
          //   department: productDepartmentPreference,
          //   unit: productUnitPreference,
          //   volume: productVolumePreference,
          //   weight: productWeightPreference,
          // },
          generateOrder: {
            create:
              preferencesForProducts === "do not generate invoice" ||
              preferencesForProducts === "find create product"
                ? false
                : true,
            // mapping: {
            //   txDefaultProduct:
            //     preferencesForProducts === "use default product" &&
            //     productPreference?.value
            //       ? productPreference
            //       : {},
            // },
            mapping:
              preferencesForProducts === "use default product" &&
              productPreference?.value
                ? {
                    txDefaultProduct: productPreference,
                  }
                : {},
          },
          createProduct: {
            customProduct: {
              useTxDefaultProduct:
                preferencesForProducts === "find create product" &&
                preferenceForCreatingProduct
                  ? true
                  : false,
              // mapping: {
              //   txDefaultProduct:
              //     preferenceForCreatingProduct &&
              //     preferencesForProducts === "find create product" &&
              //     defaultProductForCreating?.value
              //       ? defaultProductForCreating
              //       : {},
              // },
              mapping:
                preferenceForCreatingProduct &&
                preferencesForProducts === "find create product" &&
                defaultProductForCreating?.value
                  ? {
                      txDefaultProduct: defaultProductForCreating,
                    }
                  : {},
            },
            create:
              preferencesForProducts === "find create product" ? true : false,
          },
          filterOptions: {
            filterTxProperty: txProductFilterPreference,
            filterHsProperty: hubspotProductFilterPreference,
          },
          searchParameters:
            preferenceForSearchParameters === "select search parameters"
              ? false
              : true,
        },
      },
      preferenceType: "product",
    });
    dispatch(setIsProductSyncRulesSaved());
    dispatch(
      setShowSuccessModal({
        message:
          "cmsContent.notifications.syncSettings.successContent.productSyncRules.message",
      })
    );
  } catch (error) {
    console.log(error);
    let errorMessage;
    if (error.response && error.response.data.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    console.log(errorMessage);
    dispatch(setShowErrorModal({ message: errorMessage }));
  } finally {
    setIsLoading(false);
  }
}
